import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HeadManager from './components/HeadManager';
import staticContentManager from './utils/staticContent';
import Header from './components/Header';
import Footer from './components/Footer';
import Me from './pages/Me';
import OtaYhteytta from './pages/OtaYhteytta';
import Ratkaisut from './pages/Ratkaisut';
import TyoelamanPelit from './pages/TyoelamanPelit';

export default class App extends React.Component {
  state = {
    data: [],
    loading: true,
    error: null
  };

  componentDidMount() {
    this.fetchStaticContent();
    document.getElementsByTagName('html')[0].classList.add('animate');
    window.scrollTo(0, 0);
    
    // Set default title (replacing Helmet defaultTitle)
    document.title = 'Sanoma Games';
  }

  fetchStaticContent = () => {
    // Only update error state, not loading state
    this.setState({ error: null });
    
    staticContentManager.getEntries()
      .then(entries => {
        this.setState({ 
          data: entries.items,
          loading: false 
        });
      })
      .catch(error => {
        console.error("Error fetching static content:", error);
        this.setState({ 
          loading: false,
          error: "Failed to load content. Please try again."
        });
      });
  }

  render() {    
    return (
      <div>
        <HeadManager
          meta={[
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            { name: 'apple-mobile-web-app-capable', content: 'yes' },
            { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
            { name: 'theme-color', content: '#c1347a' },
            { name: 'HandheldFriendly', content: 'true' },
            { name: 'keywords', content: '' },
            { name: 'copyright', content: 'Sanoma Games' }
          ]}
        />
        <BrowserRouter>
          <div>
            <Header />
            <main>
              <div className='page'>
                <Routes>
                  <Route path='/' element={<Ratkaisut data={this.state.data} loading={this.state.loading} error={this.state.error} retryFetch={this.fetchStaticContent} />} />
                  <Route path='/me' element={<Me data={this.state.data} loading={this.state.loading} error={this.state.error} retryFetch={this.fetchStaticContent} />} />
                  <Route path='/ota-yhteytta' element={<OtaYhteytta data={this.state.data} loading={this.state.loading} error={this.state.error} retryFetch={this.fetchStaticContent} />} />
                  <Route path='/tyoelama' element={<TyoelamanPelit data={this.state.data} loading={this.state.loading} error={this.state.error} retryFetch={this.fetchStaticContent} />} />
                  <Route path='*' element={<Ratkaisut data={this.state.data} loading={this.state.loading} error={this.state.error} retryFetch={this.fetchStaticContent} />} />
                </Routes>
              </div>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}
